import { useState } from "react";
import { ListPicker } from "../../components/generic/ListPicker";
import { SettingItem } from "../../components/orgSettings/SettingsItem";
import { usePickerhook } from "../../hooks/usePickerhook";
import { CiLight } from "react-icons/ci";
import { CiDark } from "react-icons/ci";
import { PiDesktopThin } from "react-icons/pi";

export default () => {
  const themeItems = [
    { name: "Dark", icon: <CiDark className="inline" />, code: "dark" },
    {
      name: "Match Browser",
      icon: <PiDesktopThin className="inline" />,
      code: "browser",
    },
    {
      name: "Light",
      icon: <CiLight className="inline" />,
      code: "light",
    },
  ];
  const [selectedTheme, setselectedTheme] = useState("browser");

  const TimeZonepicked = usePickerhook();
  const Languagepicked = usePickerhook();

  const TimeZoneAction = (
    <ListPicker
      hook={TimeZonepicked}
      notitle
      maxwidth
      defaultvalue={{ name: "UTC", code: "utc" }}
      list={[]}
    />
  );
  const LanguageAction = (
    <ListPicker
      maxwidth
      hook={Languagepicked}
      notitle
      defaultvalue={{ name: "English", code: "english" }}
      list={[]}
    />
  );
  const ThemeAction = (
    <div className=" w-[250px]  flex justify-center items-center gap-2 p-2 rounded-full border border-gray-200 my-4">
      {" "}
      {themeItems.map((item: any) => (
        <p
          onClick={() => {
            setselectedTheme(item.code);
          }}
          className={` cursor-pointer inline text-xs font-semibold p-1 rounded-full ${
            item.code == selectedTheme ? "bg-primary shadow text-white" : ""
          }`}
        >
          {" "}
          {item.name} {item.icon}
        </p>
      ))}
    </div>
  );
  return (
    <div className="w-full pr-20  flex  ">
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Preferences
          </p>
        </div>

        <hr />
        <div className="mt-4 flex flex-col gap-2">
          <SettingItem title="Timezone" action={TimeZoneAction} />
          <SettingItem title="Language" action={LanguageAction} />
          <SettingItem title="Theme" action={ThemeAction} />
        </div>
      </div>
    </div>
  );
};
